import { type IConversions } from "./IConversions";
import { type IConversionStore } from "./ConversionStore";

export class StoreConversions<S, T> implements IConversions<S, T> {
	private readonly store: IConversionStore<S, T>;

	constructor(store: IConversionStore<S, T>) {
		this.store = store;
	}

	data(key: S): T {
		return (this.store.items as any)[key];
	}

	load(keys: S[]): Promise<void> {
		return this.store.load(keys);
	}

	get isResetting(): number {
		return this.store.isResetting;
	}

	invalidate(key: S): Promise<void> {
		return this.store.invalidate(key);
	}
}
